import toThreadTimestampMs from '@/lib/threads/toThreadTimestampMs.js';

/** Conversations newest activity first (last update, else creation), own and organization ones mixed. Returns a new array. */
const sortThreadItemsByActivity = (items) => {
  const toTime = (item) => toThreadTimestampMs(item.updatedAt || item.createdAt) || 0;
  return [...items].sort((a, b) => toTime(b) - toTime(a));
};

export default sortThreadItemsByActivity;
